import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '@providers/context/services/authService';
import AuthContext from '@providers/context/componenets/AuthContext';
export default function Logout() {
    const navigate = useNavigate();
    const { logoutSubmitHandler } = useContext(AuthContext)

    useEffect(() => {
        authService.logout()
            .then(() => {
                logoutSubmitHandler();
                navigate('/login');
            })
            .catch((error) => {
                console.error('Logout error:', error);
            })
    }, [navigate, logoutSubmitHandler]);
    return null
}
